import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { NavLinksBaseComponent } from './base-component/nav-links-base.component';
import { IdType, KeyType } from './models/nav-links.enums';
import {
  NavItem,
  NavigationUIMenuKeys,
  SecondaryNavItem
} from './models/nav-links.interfaces';
@Component({
  selector: 'idp-nav-links',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-links.component.html',
  styleUrls: ['./nav-links.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavLinksComponent
  extends NavLinksBaseComponent
  implements OnChanges
{
  currentIndex = 0;
  nextIndex = 0;
  @Input() isLoggedIn = false;
  @Input() isBusinessAccount = false;

  ngOnChanges(): void {
    if (this.inMobile) {
      this.showVisible(true);
    } else {
      this.showVisible(false);
    }
  }

  showVisible(flag: boolean): void {
    setTimeout(() => {
      this.isVisible = flag;
    }, 100);
  }

  onTrackingObject(id: string, label?: string): void {
    const selectedId = id as NavigationUIMenuKeys;
    this.analyticsEvent.emit({ id: selectedId, label: label });
    this.secondaryNavAction.emit({
      type: 'click',
      secondaryId: id,
      id: IdType.SECONDARY
    });
    this.selectedSecNav = id;
  }

  onPrimaryNavClick(
    id: string,
    legacyAppUrl: string,
    redirectMobile: boolean,
    redirectMobileUrl: string
  ): void {
    this.selectedNav = id;
    this.previousSelectedPrimaryNav = id;
    this.primaryNavAction.emit({
      id,
      legacyAppUrl,
      redirectMobile,
      redirectMobileUrl
    });
  }

  onKeyEvent(event: KeyboardEvent): void {
    const allNavItems = [...this.content.primary, ...this.content.secondary];

    switch (event.key) {
      case KeyType.ARROW_RIGHT: {
        event.preventDefault();
        this.currentIndex = (this.currentIndex + 1) % allNavItems.length;
        this.handleNavigation(allNavItems[this.currentIndex]);
        break;
      }

      case KeyType.ARROW_LEFT: {
        event.preventDefault();
        this.currentIndex =
          this.currentIndex <= 0
            ? allNavItems.length - 1
            : this.currentIndex - 1;
        this.handleNavigation(allNavItems[this.currentIndex]);
        break;
      }
    }
  }

  handleNavigation(navItem: NavItem | SecondaryNavItem): void {
    this.currentIndex = [
      ...this.content.primary,
      ...this.content.secondary
    ].findIndex((item) => item.id === navItem.id);

    if (this.content.primary.some((item) => item.id === navItem.id)) {
      this.selectedNav = navItem.id;
      this.selectedSecNav = null;
      this.onPrimaryNavClick(
        navItem.id,
        (navItem as NavItem).details.legacyAppUrl,
        (navItem as NavItem).redirectMobile,
        (navItem as NavItem).redirectMobileUrl
      );
    } else {
      this.selectedNav = '';
      this.selectedSecNav = navItem.id;
      this.onSecondaryNavAction('mouseover', navItem.id);
    }

    setTimeout(() => {
      const elementId = this.content.primary.some(
        (item) => item.id === navItem.id
      )
        ? `headPrimary${this.currentIndex + 1}`
        : `headSectab${
            this.content.secondary.findIndex((item) => item.id === navItem.id) +
            1
          }`;

      const element = document.getElementById(elementId);
      if (element) {
        element.focus();
      }
    });
  }
}
